import * as React from "react";
import {IIconProps} from "./IIconProps";


export class Icon extends React.Component<IIconProps, {}> {

  render() {
    return <i title={this.props.title ? this.props.title : this.props.title}>
      {this.props.children}
    </i>
  }

}